export function parseJsonp(json){
    function setCharAt(str, index, chr) {
        if(index > str.length-1) return str;
        return str.substr(0,index) + chr + str.substr(index+1);
    }
    
    var pos = -1;
    while (true) {
      pos = json.indexOf('new Date', pos)
      var start = pos;
      if(start === -1)
        break;
    
      pos = json.indexOf(')', pos + 1);
      var end = pos;
      if(end === -1)
        break;
        
      json = setCharAt(json, start, "\"");  
      json = setCharAt(json, end + 1, "\"");  
    } 
    
    function dateParser(key, value) {
      if (typeof value === 'string' && value.includes("new Date")) {
        try {
          // eslint-disable-next-line no-new-func
          return new Function('return ' + value)();
        } catch (error) {
          console.warn('Failed to parse date:', value, error);
          return value; 
        }
      }
      return value;
    };
    
    var o = JSON.parse(json, dateParser);
    return o;
}